<template>
    <div>
        <div class="toogle_content">
            <form class="basic-grey">
                <span class="userName">{{userInformation.realName}}</span>
                <label>
                    <span class="leftSpan">账号 :</span>
                    <span class="rightSpan" style="color: #666;">{{userInformation.userId}}</span>
                </label>
                <!-- <label>
                    <span class="leftSpan">密码 :</span>
                    <span class="rightSpan" style="color: #333;">
                        <input type="text" name="" value="******" readonly="readonly">
                        <i @click="altPassWord">修改密码</i>
                    </span>
                </label> -->
                <!-- <label>
                <span class="leftSpan" style="padding-left: 10px;">性别 :</span>
                <div class="">
                    <p class="radio">
                        <span>男</span>
                        <span class="sex" :class="{'checkSex': check}" @click="modify"></span>
                    </p>
                    <p class="radio">
                        <span>女</span>
                        <span class="sex" :class="{'checkSex': !check}" @click="modify"></span>
                    </p>
                </div>
            </label> -->
                <ul>
                    <li class="school">
                        <span>学校：</span>
                        <p>{{school}}</p>
                    </li>
                    <li class="grads">
                        <span>班级：</span>
                        <p>{{grads}}</p>
                    </li>
                </ul>
            </form>

            <div>
                <alertPW :layerPW="layerPW" :password="userInformation.password"></alertPW>
            </div>
        </div>

    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fetch from "./../../fetch";
import alertPW from "./../alertMsg/alertPW.vue";
import { nowDate, formatDate, aroundDate, timeStamp } from "./../../filter";

export default {
  data() {
    return {
      layerPW: false,
      check: "",
      school: [],
      grads: []
    };
  },
  props: ["userInformation", "birthday", "userId"],
  components: {
    alertPW
  },
  watch: {
    userInformation(val) {
      this.check = this.userInformation.sex;
      this.schoolList();
    }
  },
  created() {
    this.$nextTick(() => {
        
    });
  },

  methods: {
    ...mapGetters(["getUser"]),
    altPassWord() {
      this.layerPW = !this.layerPW;
    },

    schoolList() {
      let classes = this.userInformation.classes;
      let schoolArr = [];
      let gradsArr = [];
      for (var i = 0; i < classes.length; i++) {
        schoolArr.push(classes[i].schoolName);
        gradsArr.push(classes[i].className);
      }
      for (var i = 0, j = schoolArr.length; i < j; i++) {
        if (this.school.indexOf(schoolArr[i]) == -1) {
          this.school.push(schoolArr[i]);
        }
      }
      this.school = this.school.toString();
      for (var i = 0, k = gradsArr.length; i < k; i++) {
        if (this.grads.indexOf(gradsArr[i]) == -1) {
          this.grads.push(gradsArr[i]);
        }
      }
      this.grads = this.grads.toString();
    }

    // altMobile() {
    //   this.layerMB = !this.layerMB;
    // },

    // modify() {
    //   this.check = !this.check;

    //   if (!this.check) {
    //     fetch.modifySex({ sex: 0 }).then(res => {
    //       if (!res) {
    //         return false;
    //       }
    //       this.$toast("修改成功", "right");
    //     });
    //   } else {
    //     fetch.modifySex({ sex: 1 }).then(res => {
    //       if (!res) {
    //         return false;
    //       }
    //       this.$toast("修改成功", "right");
    //     });
    //   }
    // }
  }
};
</script>



// WEBPACK FOOTER //
// basicMsg.vue?1647c405